import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { onMenuMatrices, onUpdateMatrice } from "../../controller/SecurityController";
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { MenuModel } from "../../dto/MenuModel";
import { RoleModel } from "../../dto/RoleModel";
import { MenuGroupModel } from "../../dto/MenuGroupModel";
import Alert from "react-bootstrap/Alert";
import { RoleMenuItemModel } from "../../dto/RoleMenuItemModel";
import { MenuItemModel } from "../../dto/MenuItemModel";
import { EventBusyTwoTone } from "@mui/icons-material";
import { ToastBody } from "react-bootstrap";

const MenuMatrice = () => {
    const [menus, setMenus] = useState<Array<MenuModel>>([]);
    const [roles, setRoles] = useState<Array<RoleModel>>([])
    const [map, setMap] = useState<Array<RoleMenuItemModel>>([]);
    const [newMenuRole, setNewMenuRole] = useState<MenuItemModel>({
        value: '',
        menuName: '',
        checked: undefined
    })
    const [complete, setCompleted] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (!AuthUtility.isUserLoggedIn()) {
            navigate("/login");
            window.location.reload();
        } else {
            menuMatriceGet();
        }
    }, []);

    useEffect(() => {
        if (newMenuRole.value !== '') {
            updateMatrice();
        }
    }, [newMenuRole]);


    const updateMatrice = async () => {
        const response = await onUpdateMatrice(newMenuRole);
        console.log(response);
        toast.success(response.msg);
    }

    const menuMatriceGet = async () => {
        const response = await onMenuMatrices();
        setMenus(response.menus);
        setRoles(response.roles);
        setMap(response.roleMenus);
    }

    return (
        <div className="container-fluid">
            <div><Toaster position="top-right"  reverseOrder={false}/></div>
            <div className="page-header mt-3">
                <h3 className="mb-30"><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Цэсний матриц</h3>
            </div>
            <div className="row">
                <table className="table">
                    <thead>
                        <tr>
                            <th></th>
                            {
                                menus.map((menu, index) => {
                                    return <th key={index}>{menu.menuName}</th>
                                })
                            }
                        </tr>
                    </thead>
                    <tbody>
                    {
                        map.map((roleMenu, index) => {
                            return <tr key={index}>
                                <th>{roleMenu.roleName}</th>
                                    {
                                        roleMenu.roleMenu.map((m, idx) => {
                                            if (m.checked) {
                                                return <td key = {idx}>
                                                    <input type = "checkbox"
                                                    value = {m.value}
                                                    onChange = {(event) => {
                                                        if (event.target.checked) {
                                                            setNewMenuRole({
                                                                ...newMenuRole,
                                                                value: event.target.value,
                                                                checked: true
                                                            })
                                                            event.target.removeAttribute("checked");
                                                        } else {
                                                            setNewMenuRole({
                                                                ...newMenuRole,
                                                                value: event.target.value,
                                                                checked: false
                                                            })
                                                            event.target.setAttribute("checked", "true");
                                                        }
                                                    }}
                                                    checked/>
                                                    </td>
                                            } else {
                                                return <td key = {idx}>
                                                    <input type = "checkbox"
                                                    value = {m.value}
                                                    onChange = {(event) => {
                                                        if (event.target.checked) {
                                                            setNewMenuRole({
                                                                ...newMenuRole,
                                                                value: event.target.value,
                                                                checked: true
                                                            })
                                                            event.target.removeAttribute("checked");
                                                        } else {
                                                            setNewMenuRole({
                                                                ...newMenuRole,
                                                                value: event.target.value,
                                                                checked: false
                                                            })
                                                            event.target.setAttribute("checked", "true");
                                                        }
                                                    }}/>
                                                    </td>
                                            }
                                        })
                                    }
                                </tr>
                        })
                    }
                    </tbody>
                </table>
            </div>
        </div>
  )
}

export default MenuMatrice;
